import request from '@/utils/request.js'
const querystring = require('querystring')


// 修改密码
export function updatePassword(payload) {
  return request.post(`/hcp/teacherSpace/updatePassword`, payload)
}



export function checkFollowedStatus() {
  return request.get("/hcp/teacherSpace/todbs")
}

export function checkShowParams() {
  return request.get("/hcp/base/base/config/showWechatPublicAccount")
}

export function createQrCode(payload) {
  const url = "/pages/wxPages/publicAccount/index"
  const scene = `phone=${payload.phone}&zone=${payload.zone}`
  return request.get("/hcp/base/wxMiniApp/gmcurl", {
    params: {
      url, scene
    }
  })
}


// WEBPACK FOOTER //
// ./src/services/user.js